import { authService } from "~/services/authService";

export const useRefreshToken = async () => {
  return (await authService()).refreshToken();
};
